import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { PDP_CUSTOMIZE_TAB_ID, PDP_DECIDELATER_TAB_ID } from 'commons/constants';
import CtaButton from 'components/essentials/Cta/CtaButton';
import SuspenseWithLoader from 'components/consumer/SuspenseWithLoader';
import useProductEFGInternalStatus from 'data-hooks/useProductEFGInternalStatus';
import usePDPBasicDetails from 'components/consumer/PDP/state/context/usePDPBasicDetails';
import usePDPOptions from '../state/context/usePDPOptions';
import usePdpSelectedCustomizerTab from '../state/pdpSelectedCustomizerTab/usePdpSelectedCustomizerTab';
import useSetPdpSelectedCustomizerTab from '../state/pdpSelectedCustomizerTab/useSetPdpSelectedCustomizerTab';

// Decide Later leaves the tab bar in the layout revamp; mirrors the conditions
// PDPShopTabsBar applies to the tab item it replaces
const PDPDecideLaterButtonInner = t0 => {
  const $ = _c(7);
  const {
    isEditOrder: t1
  } = t0;
  const isEditOrder = t1 === undefined ? false : t1;
  const {
    data: t2
  } = usePDPOptions();
  const {
    upholsteryOptionId
  } = t2 === undefined ? {} : t2;
  const {
    isEFGInternal
  } = useProductEFGInternalStatus();
  const {
    data: basicDetails
  } = usePDPBasicDetails();
  const pdpSelectedCustomizerTab = usePdpSelectedCustomizerTab();
  const setPdpSelectedCustomizerTab = useSetPdpSelectedCustomizerTab();
  if (isEditOrder || isEFGInternal || !upholsteryOptionId) {
    return null;
  }
  const isActive = pdpSelectedCustomizerTab === PDP_DECIDELATER_TAB_ID;
  const price = basicDetails?.meta?.price;
  const promoText = price?.max_discount_percent ? ` (lock in up to ${price.max_discount_percent}% off)` : price?.discount_percent ? ` (lock in ${price.discount_percent}% off)` : "";
  const t3 = isActive ? "solid-button" : "outline-button";
  let t4;
  if ($[0] !== isActive || $[1] !== setPdpSelectedCustomizerTab) {
    t4 = () => setPdpSelectedCustomizerTab(isActive ? PDP_CUSTOMIZE_TAB_ID : PDP_DECIDELATER_TAB_ID);
    $[0] = isActive;
    $[1] = setPdpSelectedCustomizerTab;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const t5 = isActive ? "Choose a fabric now" : `Decide Later${promoText}`;
  let t6;
  if ($[3] !== t3 || $[4] !== t4 || $[5] !== t5) {
    t6 = <div className="mt-4" data-xc="PDPDecideLaterButton"><CtaButton block={true} color="brand" spacing="sm" styling={t3} onClick={t4}>{t5}</CtaButton></div>;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  return t6;
};
PDPDecideLaterButtonInner.propTypes = {
  isEditOrder: PropTypes.bool
};
const PDPDecideLaterButton = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <SuspenseWithLoader><PDPDecideLaterButtonInner {...props} /></SuspenseWithLoader>;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export default PDPDecideLaterButton;